import Constant from "./Constant";

export const PRINT_STATE = {
    OFF: "off",
    PRINTING: "printing",
    PRELOADED: "preloaded",
    READY: "ready",
    EMPTY: "empty",
};

const hasTaskWithStatus = (tasks, statuses) => tasks.some(task => statuses.includes(task.status));

export function getMachinePrintState(machine) {
    const tasks = machine.tasks || [];

    if (!machine.power) {
        return {state: PRINT_STATE.OFF, canPrint: false};
    }

    // Le statut 6 ne dure que 2 s (validation des préchargés), mais un appui pendant ce laps publierait un message d'impression de plus.
    if (hasTaskWithStatus(tasks, [Constant.TASK_STATUS_IN_PROGRESS, Constant.TASK_STATUS_PRINTING])) {
        return {state: PRINT_STATE.PRINTING, canPrint: false};
    }

    // TaskService::traitementTask ne valide les préchargés que si la machine précharge encore ou si une tâche attend derrière.
    if (hasTaskWithStatus(tasks, [Constant.TASK_STATUS_PRELOADED])) {
        return {
            state: PRINT_STATE.PRELOADED,
            canPrint: Boolean(machine.preload) || hasTaskWithStatus(tasks, [Constant.TASK_STATUS_WAITING]),
        };
    }

    if (hasTaskWithStatus(tasks, [Constant.TASK_STATUS_WAITING])) {
        return {state: PRINT_STATE.READY, canPrint: true};
    }

    return {state: PRINT_STATE.EMPTY, canPrint: false};
}

export const countWaitingTasks = (machine) => {
    return (machine.tasks || []).filter(task => task.status === Constant.TASK_STATUS_WAITING).length
}
